import { StoredItem, writeItem } from "LibMargoWorld/item";
import { linkMap } from "LibMargoWorld/link";
import { StoredNpc, writeNpc } from "LibMargoWorld/npc";

import { initExtendedItemInfo } from "../extended-item-info/extended-info-loader";
import { loadItemsFromElement } from "../item-loader";

function getEditorValue() {
    const editor = document.querySelector("#editor");

    if (editor instanceof HTMLTextAreaElement) {
        return editor.value;
    }
    return "";
}

function updatePreview(html: string) {
    const preview = <HTMLDivElement>document.querySelector("#preview");
    preview.innerHTML = html;
    loadItemsFromElement(preview);
    initExtendedItemInfo(preview);
}

async function postUpdatePreview() {
    const url = `/admin/mdContent/preview`;

    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `data=${encodeURIComponent(getEditorValue())}`,
    });

    const text = await res.text();
    updatePreview(text);
}

const $helper = document.createElement("div");
$helper.style.overflowY = "auto";
$helper.style.height = "80vh";
let $editor: HTMLTextAreaElement;
let caretPos = 0;

function parseSearchResult(data: any) {
    const $resultWrapper = $helper.querySelector("div");
    const npcs = data.npc ? <StoredNpc[]>data.npc : [];
    const items = data.item ? <StoredItem[]>data.item : [];
    const mapNames = data.mapNames ?? {};
    const maps = data.maps ?? {};

    let html = "";
    for (let npc of npcs) {
        html += `<tr tabindex="0" data-write="NPC#${npc.id}"><td>${writeNpc(npc, npc.nick, `tabindex="-1"`)} (${npc.lvl}lvl) - ${mapNames[npc.map]} (${npc.x},${npc.y})</td></tr>`;
    }
    for (let item of items) {
        html += `<tr tabindex="0" data-write="ITEM#${item.id}"><td>${writeItem(item, `tabindex="-1"`)} ${item.name}</td></tr>`;
    }
    for (const id in maps) {
        html += `<tr tabindex="0" data-write="MAP#${id}"><td>${linkMap(parseInt(id), maps[id])}</td></tr>`;
    }
    let extraInfo = "";
    if (data.error) {
        extraInfo = `<i>${data.error}</i>`;
    } else if (!html) {
        extraInfo = "<i>Brak wyników</i>";
    }
    html = "<table style='width:100%;'>" + html + "</table>" + extraInfo;
    $resultWrapper.innerHTML = html;
    $resultWrapper.querySelector("tr")?.focus();
}

function initSearchHelper() {
    const $input = document.createElement("input");
    $input.classList.add("form-control", "form-control-sm", "w-25", "m-auto");
    $helper.appendChild(document.createTextNode("Wyszukaj npc, item lub map"));
    $helper.appendChild(document.createElement("br"));
    $helper.appendChild($input);
    const $searchResult = document.createElement("div");
    $helper.appendChild($searchResult);
    function finishSearch(text: string, e: Event) {
        $editor.value = $editor.value.substring(0, caretPos) + text + $editor.value.substring(caretPos);
        $helper.style.display = "none";
        $editor.setSelectionRange(caretPos + text.length, caretPos + text.length, "none");
        $editor.focus();
        e.preventDefault();
    }
    $searchResult.addEventListener("keydown", (e) => {
        const focused = $searchResult.querySelector(":focus");
        if (e.key == "ArrowDown") {
            // @ts-ignore
            focused.nextElementSibling?.focus();
            e.preventDefault();
        } else if (e.key == "ArrowUp") {
            if (focused.previousElementSibling) {
                // @ts-ignore
                focused.previousElementSibling.focus();
            } else {
                $input.focus();
            }
            e.preventDefault();
        } else if (e.key == "Enter") {
            const text = focused.getAttribute("data-write");
            finishSearch(text, e);
        }
    });
    $searchResult.addEventListener("click", (e) => {
        if (e.target instanceof HTMLElement) {
            const tr = e.target.closest("tr");
            if (tr) {
                const text = tr.getAttribute("data-write");
                finishSearch(text, e);
            }
        }
    });

    Object.assign($helper.style, {
        position: "fixed",
        top: "100px",
        display: "none",
        width: "100%",
        textAlign: "center",
        padding: "10px",
        background: "rgba(0, 0, 0, 0.7)",
    });

    $input.addEventListener("keydown", async (e) => {
        if (e.key == "Enter") {
            const res = await fetch("/admin/mdContent/search", {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                method: "POST",
                body: `q=${encodeURIComponent($input.value)}`,
            });
            const json = await res.json();
            parseSearchResult(json);
        } else if (e.key == "Escape") {
            $helper.style.display = "none";
            $editor.focus();
        }
    });

    document.body.appendChild($helper);
}

function showSearchHelper() {
    caretPos = $editor.selectionStart;
    $helper.querySelector("div").innerHTML = "";
    $helper.querySelector("input").value = "";
    $helper.style.display = "block";
    $helper.querySelector("input").focus();
}

export function initMdContentEditor() {
    $editor = <HTMLTextAreaElement>document.querySelector("#editor");
    initSearchHelper();

    if ($editor instanceof HTMLTextAreaElement) {
        let changeTimeout = 0;
        $editor.addEventListener("keyup", () => {
            if (changeTimeout) {
                clearTimeout(changeTimeout);
            }
            changeTimeout = window.setTimeout(() => {
                postUpdatePreview();
                changeTimeout = 0;
            }, 500);
        });

        $editor.addEventListener("keypress", (e) => {
            if (e.ctrlKey && e.code == "KeyI") {
                showSearchHelper();
            }
        });
    }
}
